import React, { useState } from 'react';

const MessageWithReadMore = ({ message }) => {
  const [isMessageTruncated, setIsMessageTruncated] = useState(true);

  if (!message) {
    return <p className='text-md text-gray-200'>Looks like the author has not added any message yet.</p>;
  }

  const shouldShowButton = message.length > 120;
  const toggleMessage = () => setIsMessageTruncated(prev => !prev);

  return (
    <div>
      <p className="text-md text-gray-200">
        {isMessageTruncated && shouldShowButton ? (
          <span>{message.slice(0, 120)}... </span>
        ) : (
          <span>{message} </span>
        )}
        
        {shouldShowButton && (
          <button onClick={toggleMessage} className="read-more-btn ml-1 text-primary-200 font-medium">
            {isMessageTruncated ? 'Read More' : 'Read Less'}
          </button>
        )}
      </p>
    </div>
  );
};

export default MessageWithReadMore;
